const images={};
const context=require.context('./',false,/\.(png|jpeg|jpg|jfif|svg)$/i);
context.keys().forEach((key)=>{
  const imageName=key.replace('./','').replace(/\.(png|jpe?g|jfif|svg)$/,'');
  images[imageName]=context(key);
});
export default images;